import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { Router } from '@angular/router';
const screenfull = require('screenfull');

import { UserblockService } from '../sidebar/userblock/userblock.service';
import { SettingsService } from '../../core/settings/settings.service';
import { AlertsService } from '../../chatstyle/alerts/alerts.service';
import { OrganizationService } from '../../chatstyle/organization/organization.service';
import { Organization } from '../../shared/models/core.model';
import { TierService } from '../../shared/services/tier.service';

import { AuthService } from '../../auth/auth/auth.service';

import { UserAlert } from '../../shared/models/core.model';
import { AboutDialogComponent } from '../../shared/components/about-dialog/about-dialog.component';
import { OrgNotificationService } from '../../shared/services/org-notification.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

    navCollapsed = true; // for horizontal layout
    menuItems = []; // for horizontal layout
    router: Router;

  alerts: UserAlert[];

  public orgs: Organization[];
  public selectedOrg: Organization;
  private authoritativeTier: string | null = null;

    isNavSearchVisible: boolean;
    isRightPanelVisible: boolean = false;
    @ViewChild('fsbutton', { static: true }) fsbutton;  // the fullscreen button
    @ViewChild(AboutDialogComponent, { static: false }) aboutDialog: AboutDialogComponent;

  constructor(
    public userblockService: UserblockService, public settings: SettingsService, public injector: Injector,
    public alertsService: AlertsService,
    public authService: AuthService,
    public orgService: OrganizationService,
    private tierService: TierService,
    private orgNotificationService: OrgNotificationService) {

    // show only a few items on demo
    this.orgs = [];
    this.selectedOrg = null;
    }

  logout() {
    this.authService.startLogOut();
  }

  ngOnInit() {
        this.isNavSearchVisible = false;
        this.isRightPanelVisible = this.settings.getLayoutSetting('rightPanelOpen') || false;

        var ua = window.navigator.userAgent;
        if (ua.indexOf("MSIE ") > 0 || !!ua.match(/Trident.*rv\:11\./)) { // Not supported under IE
            this.fsbutton.nativeElement.style.display = 'none';
        }

        // Switch fullscreen icon indicator
        //const el = this.fsbutton.nativeElement.firstElementChild;
        //screenfull.on('change', () => {
        //    if (el)
        //        el.className = screenfull.isFullscreen ? 'fa fa-compress' : 'fa fa-expand';
        //});

        this.router = this.injector.get(Router);

        // Autoclose navbar on mobile when route change
        this.router.events.subscribe((val) => {
            // scroll view to top
            window.scrollTo(0, 0);
            // close collapse menu
            this.navCollapsed = true;
        });

    this.refreshAlerts();

    this.orgNotificationService.notificationReceived.subscribe(() => {
      this.refreshAlerts();
    });

    this.orgService.getOrganizations()
      .subscribe(
        result => {

          this.orgs = result;
          if (this.orgs) {
            if (this.orgs.length === 1) {
              this.selectedOrg = this.orgs[0];
            } else {
              for (let i = 0; i < this.orgs.length; i++) {
                if (this.orgs[i].userActive === true) {
                  this.selectedOrg = this.orgs[i];
                }
              }
              if (!this.selectedOrg) {
                this.selectedOrg = this.orgs[0];
              }
           }
           }

          if (this.selectedOrg?.id) {
            this.orgNotificationService.connect(this.selectedOrg.id);
          }

          // Load authoritative tier from organization/me (reads from Organization table directly)
          this.orgService.getMyOrganization().subscribe(
            org => {
              this.authoritativeTier = org?.tier || null;
            },
            error => console.error('Error loading authoritative tier:', error)
          );
        },
        error => console.error(error)
      );
  }

  refreshAlerts() {
    this.alertsService.getActive().subscribe({
      next: (result) => { this.alerts = result; },
      error: (err) => console.error(err)
    });
  }

  clearAlerts() {
    this.alertsService.resolveAll().subscribe({
      next: () => this.refreshAlerts(),
      error: (err) => console.error(err)
    });
  }

  changeOrg(event) {
    console.log(event);

    let id: string = this.selectedOrg.id;

    this.orgService.setActive(id).subscribe({
      next: (result) => {
        this.router.navigate(['/bots'])
          .then(() => {
            window.location.reload();
          });
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  compareOrgs(o1: Organization, o2: Organization): boolean {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }

  activeAlerts() {
      let count = 0;

      if (this.alerts && this.alerts.length > 0) {
        for (let i = 0; i < this.alerts.length; i++) {
          if (!this.alerts[i].resolved) {
            count++;
          }
        }
      }

      return count;
    }

    toggleUserBlock(event) {
        event.preventDefault();
        this.userblockService.toggleVisibility();
    }

    openNavSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        this.setNavSearchVisible(true);
    }

    setNavSearchVisible(stat: boolean) {
        // console.log(stat);
        this.isNavSearchVisible = stat;
    }

    getNavSearchVisible() {
        return this.isNavSearchVisible;
    }

    toggleOffsidebar() {
        this.settings.toggleLayoutSetting('offsidebarOpen');
    }

    toggleCollapsedSideabar() {
        this.settings.toggleLayoutSetting('isCollapsed');
    }

    isCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }

    toggleFullScreen(event) {
        if (screenfull.enabled) {
            screenfull.toggle();
        }
  }

  openAbout() {
    this.aboutDialog.open();
  }

  private getActiveTier(): string | null {
    return this.authoritativeTier ?? this.selectedOrg?.tier ?? null;
  }

  getTierDisplayName(): string {
    return this.tierService.getTierDisplayName(this.getActiveTier());
  }

  getTierIcon(): string {
    return this.tierService.getTierIcon(this.getActiveTier());
  }

  getTierBadgeClass(): string {
    return this.tierService.getTierBadgeClass(this.getActiveTier());
  }

  toggleRightPanel(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    this.isRightPanelVisible = !this.isRightPanelVisible;
    this.settings.setLayoutSetting('rightPanelOpen', this.isRightPanelVisible);
  }

  getRightPanelVisible(): boolean {
    return this.isRightPanelVisible;
  }

  openBeamer(): void {
    const beamer = (window as any).Beamer;
    if (!beamer) return;
    if (!beamer.initialized) {
      beamer.init();
    }
    beamer.show();
  }

  private setBeamerIdentity(claims: any, attempt = 0): void {
    const maxAttempts = 5;
    if ((window as any).Beamer?.update) {
      (window as any).Beamer.update({
        user_id: claims.sub || '',
        user_email: claims.email || '',
        user_firstname: claims.given_name || claims.name || ''
      });
    } else if (attempt < maxAttempts) {
      setTimeout(() => this.setBeamerIdentity(claims, attempt + 1), 100 * Math.pow(2, attempt));
    } else {
      console.warn('Beamer SDK not ready; user identity not set.');
    }
  }

  isRightPanelAvailable(): boolean {
    const rightPanelUrl = this.settings.getSetting('rightPanelUrl');
    return rightPanelUrl && rightPanelUrl !== 'about:blank' && rightPanelUrl.trim() !== '';
  }

}
